import React, { FC } from 'react';
import styled from 'styled-components';
import { Margin, P, TextLink, theme } from '@ovotech/element-v5';

interface Props {
  faqLink?: string;
  onConnectViaCharger?: () => void;
}

const FaqLink = styled(TextLink)`
  color: ${theme.color.surface.link} !important;
  font-weight: ${theme.font.weight.book} !important;
`;

const ConnectButton = styled.button`
  ${({ theme: { colors } }) => `
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    color: ${colors.primary};
    text-decoration: underline;
  `}
`;

const StandardPlansViaChargerNote: FC<Props> = ({
  faqLink,
  onConnectViaCharger,
}) => (
  <div data-testid="standard-plans-via-charger-note">
    <P>
      Since you've got a compatible charger, you can access our other Monthly
      Plans in the OVO Charge app.
      {faqLink && (
        <>
          {' '}
          <FaqLink opensInNewWindow href={faqLink}>
            See our FAQs
          </FaqLink>{' '}
          to find out more.
        </>
      )}
    </P>
    {onConnectViaCharger && (
      <Margin top={2}>
        <ConnectButton
          type="button"
          onClick={onConnectViaCharger}
          data-testid="connect-via-charger-button"
        >
          Connect via charger instead
        </ConnectButton>
      </Margin>
    )}
  </div>
);

export default StandardPlansViaChargerNote;
